<template>
  <div class="fishki">
    <!-- Блок поиска реферала как промокод -->
    <div class="referal-block">
      <div class="referal-row">
        <input 
          type="text" 
          v-model="text" 
          placeholder="Телефон реферала"
          class="referal-input"
          @keyup.enter="searChview()"
        >
        <button 
          class="referal-btn" 
          @click="searChview()"
        >
          →
        </button>
      </div>
      <p v-if="order.refferal !== null" class="success-message">
        Реферал добавлен
      </p>
    </div>
  </div>

  <!-- Окно с результатами поиска -->
  <transition name="slimeright">
    <div class="okno_full" v-if="arrayClient.length > 0">
      <div class="headnot" @click="arrayClient = []">
        <h5>Закрыть список</h5>
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.39898 0.398953C8.73093 0.0670075 9.26912 0.0670075 9.60107 0.398953L15.6011 6.39895C15.933 6.7309 15.933 7.26909 15.6011 7.60103L9.60107 13.601C9.26912 13.933 8.73093 13.933 8.39898 13.601C8.06704 13.2691 8.06704 12.7309 8.39898 12.399L12.9479 7.84999H1.00002C0.530582 7.84999 0.150024 7.46944 0.150024 6.99999C0.150024 6.53055 0.530582 6.14999 1.00002 6.14999H12.9479L8.39898 1.60103C8.06704 1.26909 8.06704 0.730899 8.39898 0.398953Z" fill="currentColor"/>
        </svg>
      </div>
      <div class="conents_okno">
        <clientitem
          v-for="(one, index) of arrayClient"
          :key="'oneUser' + index"
          @click="setClient(one)"
          :firstname="one.firstname || 'нет'"
          :lastname="one.lastname || 'нет'"
          :photo="one.avatar"
          :phone="one.phone !== null ? one.phone : 'нет номера'"
        />
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue'
import { notSet } from '@/controlles/general'
import axios from 'axios'
import clientitem from '@/components/client/clientitem.vue'
import { order } from '@/controlles/basket/basket'

const text = ref(null)
const arrayClient = ref([])

const searChview = async () => {
  try {
    if (text.value == null || text.value.length < 4) {
      notSet('Введите минимум 4 символа', 'error')
      return
    }
    const getNames = await axios.post('https://api.ultimatum.store/arm/client/refferal', { text: text.value })
    if (getNames.data.length > 0) {
      arrayClient.value = getNames.data
    } else {
      notSet('Клиент не найден', 'error')
    }
  } catch (e) {
    console.log(e)
  }
}

const setClient = (one) => {
  order.refferal = one._id
  arrayClient.value = []
  notSet('Реферал добавлен', 'good')
}
</script>

<style scoped>
.fishki {
  width: 100%;
}

/* Блок реферала как промокод */
.referal-block {
  width: 100%;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-light);
}

.referal-row {
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  width: 100%;
}

.referal-input {
  flex: 1;
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 1px solid var(--border-medium);
  font-size: 14px;
  color: var(--text-primary);
  transition: all var(--transition-fast);
      margin-bottom: 0;
}

.referal-input:focus {
  outline: none;
  border-color: var(--accent-black);
}

.referal-input::placeholder {
  color: var(--text-tertiary);
}

.referal-btn {
  width: 48px;
  height: 43px;
  background: var(--accent-black);
  color: var(--text-inverse);
  border: 1px solid var(--accent-black);
  font-size: 20px;
  cursor: pointer;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
}

.referal-btn:hover {
  background: var(--btn-accent-hover);
  border-color: var(--btn-accent-hover);
}

.success-message {
  margin: 0 20px 16px 20px;
  padding: 10px;
  text-align: center;
  color: var(--green);
  font-size: 14px;
  background: var(--green-light);
  border: 1px solid var(--green);
}

/* Окно с результатами поиска */
.okno_full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: var(--bg-primary);
  z-index: 99999;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.headnot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--header-bg);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--header-border);
  position: sticky;
  top: 0;
  z-index: 10;
  cursor: pointer;
}

.headnot h5 {
  color: var(--header-text);
  font-weight: 300;
  font-size: 14px;
  text-transform: uppercase;
  margin: 0;
}

.headnot svg {
  width: 16px;
  height: 14px;
  color: var(--header-icon-fill);
}

.headnot svg path {
  fill: currentColor;
}

.conents_okno {
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Анимация */
.slimeright-enter-active,
.slimeright-leave-active {
  transition: all var(--transition-normal);
}

.slimeright-enter-from,
.slimeright-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Темная тема */
html.dark .referal-block {
  background: var(--bg-tertiary);
}

html.dark .success-message {
  background: var(--green-dark);
  border-color: var(--green);
}

</style>